import React from 'react'
import { ValuePropositionWidget } from 'components/Widgets'

export const ValueProposition: React.FC<React.PWC<unknown>> = () => (
  <ValuePropositionWidget />
)
